var CATEGORY_PAGE_QUERY_KEY = "CategoryPageQuery";
export var createCategoryPageQueryKeyPrefix = function(param) {
    var navigationPath = param.navigationPath;
    return [
        CATEGORY_PAGE_QUERY_KEY,
        navigationPath
    ];
};
